import { useState, useEffect } from 'react';
//================ css ==============
import "swiper/swiper-bundle.min.css";
//============= assets ================
import defaultPersonImg from "assets/Images/icons/defaultPerson.png"
import StarImg from "assets/Images/icons/Starwhite.png"
import StarImgBlue from "assets/Images/icons/Star.png"
import defaultCardImg from "assets/Images/icons/defaultCardImg.png"
import reviewUSerFlag from "assets/Images/icons/flag.png";
import plusIcon from "assets/Images/icons/plusIcon.png"
//=========== components ==============
import BookingCard from "Components/profilePage/BookingCard"
import ProfileUpdateForm from "Components/profilePage/ProfileUpdateForm"
import { withRouter, Link } from 'react-router-dom'
import SliderCard from "Components/sliderCard/SliderCard"
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
    Pagination,
    Navigation,
    Autoplay,
} from "swiper";
import ProfileCard from 'Components/profilePage/ProfileCard'
import { CustomRatings } from 'Utills/CustomRatings';
import { Menu, MenuItem } from '@material-ui/core/';
import { connect } from "react-redux";
import NotLoggedIn from "Components/notLoggedIn";
import CustomModal from "Utills/Model/CustomModel";
import SiginInPopup from "Components/Popup/SiginInPopup/SiginInPopup";
// ========== functions / states /  ==============
import { useNotifyContext } from "context/notifyContext"
import axios from "axios";
import { check_current_user } from "store/actions"
import Loader from 'Components/others/Loader';
// 

// api endpoints 
let api_users = process.env.REACT_APP_API_USERS



// Swiper slider configs
SwiperCore.use([Pagination, Navigation, Pagination, Autoplay]);

//======================  This is a Profile Page according to user mode {{ captain or sailor}} =================

const Profile = (props) => {
    const { set_notify, set_loader } = useNotifyContext();
    const [loginOpen, setLogin] = useState(false);
    let user = props.current_user;
    // console.log(user,"=")
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    //============== handle open review filter menu  ===============
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    //====================== handle close review filter menu  ===================
    const handleClose = () => {
        setAnchorEl(null);
    };

    //  Form  fields state
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        birthdate: '',
        nationality: "",
    });

    // password form state
    const [passwordForm, setPasswordForm] = useState({
        current_password: "************",
        new_password: "",
        confirm_password: "",
    })

    //=======================  Get user details and set in form if user is logged in ===============================
    useEffect(() => {
        if (user && user?.isAuth) {
            setFormData({
                ...user,
                first_name: user.name || "",
                last_name: user.surname || "",

            })
        } else {
            setFormData({
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
                birthdate: '',
                nationality: "",
            })
        }
    }, [props.current_user]) // eslint-disable-next-line react-hooks/exhaustive-deps

    //===================== handle form input when change ======================

    const handlePersonalForm = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        })
    };

    //==================== handle password form input when change =====================
    const handlePasswordForm = (e) => {
        const { name, value } = e.target;
        setPasswordForm({
            ...passwordForm,
            [name]: value,
        })
    };

    // =============== check for age validity ===================================
    // function underAgeValidate(birthday) {
    //     // it will accept two types of format yyyy-mm-dd and yyyy/mm/dd
    //     var optimizedBirthday = birthday?.toString()?.replace(/-/g, "/");

    //     //set date based on birthday at 01:00:00 hours GMT+0100 (CET)
    //     var myBirthday = new Date(optimizedBirthday);

    //     // set current day on 01:00:00 hours GMT+0100 (CET)
    //     var currentDate = new Date().toJSON().slice(0, 10) + ' 01:00:00';

    //     // calculate age comparing current date and borthday
    //     var myAge = ~~((Date.now(currentDate) - myBirthday) / (31557600000));

    //     if (myAge < 18) {
    //         return false;
    //     } else {
    //         return true;
    //     }

    // };

    // ===================== Submit form to  update user details =============================
    const submitProfileUpdate = async (e) => {
        e.preventDefault();
        // if (formData?.birthdate?.toString()?.length > 0) {
        //     if (underAgeValidate(formData.birthdate)) {
        set_loader(true)
        let token = await localStorage.getItem("cyan_user");
        let userToken = JSON.parse(token) || ""
        let data = {
            "name": formData.first_name,
            "surname": formData.last_name,
            "country": formData.nationality,
            "phone": formData.phone
        };
        axios({
            method: "PUT",
            url: api_users,
            data: data,
            headers: {
                'Authorization': `Token ${userToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        })
            .then((response) => {
                let data = response?.data;
                if (data.status !== "error") {
                    props.check_current_user(null, () => {
                        set_loader(false);
                        set_notify({ open: true, msg: "Profile updated Successfully.", type: "success" })
                    })
                } else {
                    set_loader(false);
                    set_notify({ open: true, msg: data?.['error-message'], type: "error" })
                    console.log("Error when updating profile ===>", data);
                }
            }).catch((err) => {
                set_loader(false);
                set_notify({ open: true, msg: err.message, type: "error" })
                console.log("Error when updating profile ====>", err.message);
            })

        //     } else {
        //         set_notify({ open: true, msg: "Age should be 18 or greater.", type: "error" })
        //     }
        // } else {
        //     set_notify({ open: true, msg: "Age is required.", type: "error" })
        // }
    };

    //  ======================= check user is logged in or not ===========================
    if (user && user?.isAuth) {
        //=========================== check logged in user mode captain or sailor and show their profile page accordingly ===========================
        if (user.is_captain === true) {
            //================ captain =================
            return (
                <>
                    <div className="profile-page-container container header-spacer">
                        <div className="row">
                            <div className="col-lg-3 mb-3  col-12">
                                <ProfileCard data={{
                                    profilePage: true,
                                    profileImg: user?.profileImg || '.',
                                    userName: user.name + ' ' + user.surname + " ",
                                    // userName: 'Satrious Jonson',
                                    subInfo: '38, Greece',
                                    mode: user?.is_captain,
                                    heading2: "All Listings Boats",
                                    heading3: "All Reviews"
                                }} />
                            </div>
                            <div className="col-lg-9 mb-3  col-12 p-0">
                                <ProfileUpdateForm
                                    data={formData}
                                    setData={setFormData}
                                    handlePersonalForm={handlePersonalForm}
                                    passwordData={passwordForm}
                                    handlePasswordForm={handlePasswordForm}
                                    submitProfileUpdate={submitProfileUpdate}
                                />
                                {/* Booking History */}
                                <div className="mt-5 pt-5 pb-5 mb-3 px-lg-1 px-3">
                                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
                                        <h4 className="text-muted all-listing-heading">All Listing ( <span className="text-primary">3</span> )</h4>
                                        <Link to="/AddBoat"><h4 className="text-sec all-listing-heading"><img src={plusIcon} alt="" /> &nbsp; Add New Boat</h4></Link>
                                    </div>
                                    {[0, 1, 2].map((v, i) => {
                                        return (
                                            <BookingCard
                                                key={i}
                                                data={{
                                                    mode: user?.is_captain,
                                                    img: defaultCardImg,
                                                    mainTitle: "Booking Information",
                                                    title: "Motorboat Azimut 62",
                                                    location: "Crete.Greece",
                                                    subtitle: "Starting Price",
                                                    guests: 'Up to 10',
                                                    boatType: "Yacht",
                                                    bookingType: 'Intra Day | Over Night',
                                                    price: "1260",
                                                    days: 'Day',
                                                    reviewText: "The trip was awesome! I could bring over my friends and got intraday booking so easily. The captain was so friendly. Thank you"
                                                }}
                                            />
                                        )
                                    })}
                                </div>
                            </div>
                            {/*   Revies section */}
                            <div className="col-12">
                                <h4 className="text-muted px-2 mb-4">All Reviews (<span className="text-sec"> 21 </span>)</h4>
                                <div className="all-reviews-btn-sec">
                                    <button className="reviews-btn">Reviews</button>
                                    <div className="d-flex starsss justify-content-end align-content-center  my-md-0 my-3">
                                        <CustomRatings className="mx-3" />
                                        <h5>4.8</h5> &nbsp;&nbsp;<span className="text-muted">(230)</span>
                                    </div>

                                    <div className="all_listings">
                                        <button
                                            id="listing-menu"
                                            aria-controls="listing-menu"
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            onClick={handleClick}
                                        >All Listing
                                            <span>
                                                <svg width="15" height="13" viewBox="0 0 15 13" fill="none">
                                                    <path d="M5.8428 12.4578C5.7732 12.39 5.4756 12.134 5.2308 11.8955C3.6912 10.4974 1.1712 6.85003 0.402 4.94102C0.2784 4.6511 0.0168 3.91812 0 3.5265C0 3.15124 0.0864 2.79352 0.2616 2.45217C0.5064 2.02665 0.8916 1.68529 1.3464 1.49825C1.662 1.37784 2.6064 1.1908 2.6232 1.1908C3.6564 1.00375 5.3352 0.900879 7.1904 0.900879C8.958 0.900879 10.5684 1.00375 11.6172 1.15689C11.634 1.17443 12.8076 1.36147 13.2096 1.56605C13.944 1.94131 14.4 2.67428 14.4 3.4587V3.5265C14.382 4.03736 13.926 5.11169 13.9092 5.11169C13.1388 6.91783 10.7424 10.481 9.15 11.9131C9.15 11.9131 8.7408 12.3164 8.4852 12.4917C8.118 12.7653 7.6632 12.9009 7.2084 12.9009C6.7008 12.9009 6.228 12.7477 5.8428 12.4578Z" fill="#212121" />
                                                </svg>
                                            </span>
                                        </button>

                                        <Menu
                                            id="listing-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            MenuListProps={{
                                                'aria-labelledby': 'listing-button',
                                            }}
                                        >
                                            <MenuItem onClick={handleClose}>Most recent</MenuItem>
                                            <MenuItem onClick={handleClose}>Most Oldest</MenuItem>
                                            <MenuItem onClick={handleClose}>Top rated</MenuItem>
                                        </Menu>
                                    </div>
                                </div>
                                <div className="about-ratings">
                                    <div className="about-ratings-card">
                                        <p>Ratings Fields</p>

                                        <li>Booking time and availability <span><img src={StarImg} alt="" /> 4.9</span></li>
                                        <li>Listings as described<span> <img src={StarImg} alt="" /> 4.8</span></li>
                                        <li>Would book again <span><img src={StarImg} alt="" /> 4.7</span></li>
                                    </div>
                                    <div className="reviews-with-percents">
                                        <ul>
                                            <li>
                                                <span className="name-of-stars">5 stars</span>
                                                <span className="percnt-wrap"><div className="perct-fill tw-h"></div></span>
                                                <span className="num-of-ratings">(200)</span>
                                            </li>
                                            <li>
                                                <span className="name-of-stars">4 stars</span>
                                                <span className="percnt-wrap"><div className="perct-fill twnt"></div></span>
                                                <span className="num-of-ratings">(20)</span>
                                            </li>
                                            <li>
                                                <span className="name-of-stars">3 stars</span>
                                                <span className="percnt-wrap"><div className="perct-fill fiv"></div></span>
                                                <span className="num-of-ratings">(5)</span>
                                            </li>
                                            <li>
                                                <span className="name-of-stars">2 stars</span>
                                                <span className="percnt-wrap"><div className="perct-fill thr"></div></span>
                                                <span className="num-of-ratings">(3)</span>
                                            </li>
                                            <li>
                                                <span className="name-of-stars">1 stars</span>
                                                <span className="percnt-wrap"><div className="perct-fill twoo"></div></span>
                                                <span className="num-of-ratings">(2)</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="row mt-5 pt-4 mb-5 pb-3">
                                    <div className="col-lg-8 ml-auto">
                                        {[0, 1, 2, 3, 4, 5,].map((v, i) => {
                                            return (
                                                <div key={i} className="mb-4">
                                                    <div className="public-review-wrapper">
                                                        <div className="review-user-avatar">
                                                            <img src={defaultPersonImg} alt="" />
                                                        </div>
                                                        <div className="user-public-revs">
                                                            <div className="reves-uers-name pb-3">
                                                                <h6>Alex Jonson</h6>
                                                                <img src={reviewUSerFlag} alt="" />
                                                                &nbsp;<span className="text-muted">Greece</span>
                                                            </div>
                                                            <div className="revs-user-rats">
                                                                <img className="mx-1" src={StarImgBlue} alt="" />
                                                                <h6>5.0</h6>
                                                            </div>
                                                            <p className="text-muted">
                                                                Really fast service. Amazing work . Definitely will be using services again. Thank you.
                                                            </p>
                                                        </div>

                                                    </div>
                                                    <div className="text-right w-100 text-muted px-3">00-00-2021</div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </>
            )
        } else {
            // ================ sailor =================
            return (
                <>
                    <div className="profile-page-container container header-spacer">
                        <div className="row">
                            <div className="col-lg-3  mb-3 col-12">
                                <ProfileCard data={{
                                    profilePage: true,
                                    profileImg: user?.profileImg || '.',
                                    userName: user.name + ' ' + user.surname + " ",
                                    subInfo: '38, Greece',
                                    mode: 'Sailor',
                                    heading2: "All booking history",
                                    heading3: "Favorite List"
                                }} />
                            </div>
                            <div className="col-lg-9 mb-3  col-12 p-0">
                                <ProfileUpdateForm
                                    data={formData}
                                    setData={setFormData}
                                    handlePersonalForm={handlePersonalForm}
                                    passwordData={passwordForm}
                                    handlePasswordForm={handlePasswordForm}
                                    submitProfileUpdate={submitProfileUpdate}
                                />
                                {/* Booking History */}
                                <div className="mt-5 pt-5 pb-5 mb-3 px-lg-1 px-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h4 className="text-muted mb-4">All Bookings History  ( <span className="text-primary">3</span> )</h4>
                                    </div>
                                    {[0, 1, 2].map((v, i) => {
                                        return (
                                            <BookingCard
                                                key={i}
                                                data={{
                                                    mode: user?.is_captain,
                                                    img: defaultCardImg,
                                                    mainTitle: "Booking Information",
                                                    title: "Motorboat Azimut 62",
                                                    location: "Crete.Greece",
                                                    subtitle: "Booking Cost",
                                                    guests: 6,
                                                    boatType: "Yacht",
                                                    price: "1260",
                                                    days: 1,
                                                    reviewText: "The trip was awesome! I could bring over my friends and got intraday booking so easily. The captain was so friendly. Thank you"
                                                }}
                                            />
                                        )
                                    })}
                                </div>
                            </div>
                            {/*  Favorite Slider */}
                            <div className="col-12 mb-5">
                                <h4 className="text-muted px-2 mb-3">Favorite List</h4>
                                <Swiper
                                    className="pb-5"
                                    grabCursor
                                    spaceBetween={15}
                                    slidesPerView={4}
                                    pagination
                                    speed={500}
                                    // loop
                                    breakpoints={{
                                        // when window width is >= 640px
                                        100: {
                                            slidesPerView: 1,
                                        },
                                        390: {
                                            slidesPerView: 2,
                                        },
                                        550: {
                                            slidesPerView: 3,
                                        },
                                        992: {
                                            slidesPerView: 4,
                                        },
                                    }}
                                >
                                    {[0, 1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12].map((cardItem, i) => {
                                        return (
                                            <SwiperSlide className={`px-2`} key={i}>
                                                <SliderCard
                                                    user={user}
                                                    openLoginModel={setLogin}
                                                    linkEnabled={true}
                                                    link={'/yachtDetail/' + i}
                                                    data={{
                                                        id: i,
                                                        img: defaultCardImg,
                                                        title: "Motorboat Azimut 62",
                                                        location: "Crete.Greece",
                                                        price: "1260"
                                                    }}
                                                />
                                            </SwiperSlide>
                                        )
                                    })}
                                </Swiper>
                            </div>
                        </div>
                        {/* login model popUP */}
                        <CustomModal openPopup={loginOpen} setOpenPopup={setLogin} >
                            <SiginInPopup
                                closeModel={setLogin}
                            />
                        </CustomModal>
                    </div>
                </>
            )
        }
    }
    else if (props.current_user?.isLoading) {
        return (
            <div className="profile-page-container mt-5 py-5">
                <div className="container py-5 mt-5">
                    <Loader />
                </div>
            </div>
        )
    }
    else {
        //================== not logged in =====================
        return (
            <NotLoggedIn />
        )
    }
}


// REDUX CONFIGS
const mapStateToProps = (store) => ({
    current_user: store.current_user,
});
const mapDispatchToProps = (dispatch) => ({
    check_current_user: (data, otherFunc) => dispatch(check_current_user(null, otherFunc)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Profile));

